import { render } from "./StatisticsByAdvertisers.vue?vue&type=template&id=740b288b&ts=true&lang=pug"
import script from "./StatisticsByAdvertisers.vue?vue&type=script&lang=ts"
export * from "./StatisticsByAdvertisers.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__